import { CONTENT_TOOLS_QUERY_PARAMS } from './contentToolsQueryParams';

/**
 * Links between the three content builders. Each opens the destination on the same course, module or question,
 * so jumping between the Question Library, Module Builder and Course Builder keeps the admin's place.
 */
const contentToolsHref = (tab: string, params: Record<string, string | number | null | undefined>) => {
  const search = new URLSearchParams({ [CONTENT_TOOLS_QUERY_PARAMS.tab]: tab });
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') search.set(key, String(value));
  });
  return `/admin/content?${search.toString()}`;
};

/** A course ('unassigned' for modules that are not in any course). */
export type ContentCourseRef = number | 'unassigned';

/**
 * Question Library, By course: the course, with the module open and the question selected when given.
 * With only a question it opens that question on its own.
 */
export const questionLibraryHref = ({
  courseId,
  flowId,
  questionId,
}: { courseId?: ContentCourseRef | null; flowId?: number | null; questionId?: number | null }) => {
  const ql = CONTENT_TOOLS_QUERY_PARAMS.questionLibrary;
  return contentToolsHref('question-library', {
    [ql.courseId]: courseId,
    [ql.flowId]: courseId != null ? flowId : null,
    [ql.questionId]: questionId,
  });
};

/**
 * Module Builder with the module open. With a course it opens the By course tab on that course (so the outline
 * matches); without one it opens the All modules tab, which can show any module.
 */
export const moduleBuilderHref = ({ courseId, flowId }: { courseId?: ContentCourseRef | null; flowId?: number | null }) => {
  const fb = CONTENT_TOOLS_QUERY_PARAMS.flowBuilder;
  return contentToolsHref('flow-builder', {
    [fb.mode]: courseId == null && flowId != null ? 'all' : null,
    [fb.courseId]: courseId,
    [fb.flowId]: flowId,
  });
};

/** Course Builder with the course open. */
export const courseBuilderHref = (courseId: number) =>
  contentToolsHref('course-builder', { [CONTENT_TOOLS_QUERY_PARAMS.courseBuilder.courseId]: courseId });
